// extracted by mini-css-extract-plugin
export default {"basicOverlay":"ModalWindow_basicOverlay__mxufs","basicClassModal":"ModalWindow_basicClassModal__hVIVe"};